<template>
  <AddArticle update />
</template>
<script>
import appConfig from '@/app.config'
import AddArticle from '../../../components/dadban/articles/AddArticle.vue'
export default {
  page: {
    title: 'ویرایش مقاله',
    meta: [
      {
        name: 'description',
        content: appConfig.description,
      },
    ],
  },
  name: 'dadban-edit-articles',
  components: {
    AddArticle,
  },
}
</script>
